import { MEGA_MENU_URLS } from '@/components/MegaMenu/megaMenuConstants/content';
import { MFE } from '@/utilities/constants';

export const DATA_API = [
  {
    title: 'Entity Information Query',
    description:
      'Provides comprehensive profile information on entities registered with ACRA',
    icon: 'Illustrative_icons-business',
    path: `/${MFE.IPS_API_MARKETPLACE}/${MEGA_MENU_URLS.SUBSCRIBE.DATA_API_CATEGORY}/eiq`,
  },
  {
    title: 'Financial Information Query',
    description:
      'Provides basic financial details for companies that have submitted their financial statements in XBRL, including financial year-end dates and auditor sign-offs',
    icon: 'Illustrative_icons-document_money',
    path: `/${MFE.IPS_API_MARKETPLACE}/${MEGA_MENU_URLS.SUBSCRIBE.DATA_API_CATEGORY}/fiq`,
  },
  {
    title: 'trustBar Verification Query',
    description:
      'Verifies the authenticity of Business Profiles, and the authenticity and currency of Business Certificates (Incorporation/Registration)',
    icon: 'Illustrative_icons-document_money',
    path: `/${MFE.IPS_API_MARKETPLACE}/${MEGA_MENU_URLS.SUBSCRIBE.DATA_API_CATEGORY}/tvq`,
  },
];

export const TRANSACTIONAL_API = [
  {
    title: 'Register',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed lacinia blandit ex eu sagittis. ',
    icon: 'Illustrative_icons-add_document',
    path: '#',
  },
  {
    title: 'Manage',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed lacinia blandit ex eu sagittis. ',
    icon: 'Illustrative_icons-convert',
    path: '#',
  },
  {
    title: 'Annual filing',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed lacinia blandit ex eu sagittis. ',
    icon: 'Illustrative_icons-calendar',
    path: '#',
  },
];

export const GET_STARTED = [
  {
    href: `${process.env.REACT_APP_BROWSER_ROUTER_BASENAME}/apimarketplace/getting-started/guide`,
    title: 'Getting started guide',
    description:
      'Access our guides on API subscription, data usage, and maximizing our API services.',
  },
  {
    href: `${process.env.REACT_APP_BROWSER_ROUTER_BASENAME}/apimarketplace/getting-started/resource-centre`,
    title: 'Resource Centre',
    description: 'Information on API integration and usage',
  },
  {
    href: `${process.env.REACT_APP_BROWSER_ROUTER_BASENAME}/apimarketplace/getting-started/faqs`,
    title: 'FAQs',
    description:
      'Answers to common queries to help you get the most out of your API Marketplace experience.',
  },
];

export const INFORMATION_PRODUCTS = [
  {
    title: 'Business Profile',
    description:
      'Provides important information like registration number, business activities and more. To buy a copy, start your entity search now.',
    path: `buy-info/info-products/business-profile`,
  },
  {
    title: 'Corporate Compliance and Financial Profile',
    description:
      'A report that provides a quick and handy checklist to gauge the financial health and compliance status of a company at one glance. To buy a copy, start your entity search now.',
    path: 'buy-info/info-products/ccfp',
  },
  {
    title: 'People Profile',
    description:
      'A report that tracks the business entities a person is / was involved in. To buy a copy, start your people search now.',
    path: 'buy-info/info-products/people-profile',
  },
  {
    title: 'Certificates',
    description:
      'Certificates show certified business information and/or status of an entity. To buy a copy, start your entity search now.',
    path: 'buy-info/info-products/certificates',
  },
  {
    title: 'Extract',
    description:
      'These are copies of forms and attachments filed by business entities, e.g. Memorandum & Articles of Association, Annual Returns or audited accounts. To buy a copy, start your entity search now.',
    path: 'buy-info/info-products/extracts',
  },
  {
    title: 'Registers',
    description:
      'Registers show either lodgement details or information related to members, directors, CEOs, secretaries or auditors of a company. To buy a copy, start your entity search now.',
    path: 'buy-info/info-products/registers',
  },
];

export const ANNOUNCEMENT = {
  TITLE: 'Announcement',
  DESCRIPTION:
    'Check out our new business information that is now available for purchase.',
};
